import * as THREE from "three";

export default function(x, y, z, color) {
  Object.setPrototypeOf(this, new THREE.PointLight(color));
  this.position.x = x;
  this.position.y = y;
  this.position.z = z;
}
